// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { KeyDirection } from "./key-direction";
import { LiftType } from "./lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * LN2 message key.
 *
 * Maps a `FlatBuffer` message triple (encoded_type, message_content,
 * message_value) to a register value for protocol translation. Used by LN1,
 * Modbus, and other offset-based protocols.
 */
export class Key implements flatbuffers.IUnpackableObject<KeyT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Key {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsKey(bb: flatbuffers.ByteBuffer, obj?: Key): Key {
    return (obj || new Key()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsKey(bb: flatbuffers.ByteBuffer, obj?: Key): Key {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Key()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  adapterId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  fbsDeviceType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  encodedType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  messageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  messageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  contentType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  /**
   * Lower-bound key for range-based mappings (e.g. Modbus
   * multi-register values). Null fields indicate single-point keys.
   */
  lowerEncodedType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  lowerMessageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  lowerMessageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  lowerFbsDeviceType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  lowerPosition(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  floorsBased(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  unitsBased(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  bankLevel(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  debounceTime(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  floorIndexing(): string | null;
  floorIndexing(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  floorIndexing(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * `FlatBuffer`-encoded key value (Config.KeyValue union).
   */
  valueBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  valueBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  valueBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Render this mapping as its own column in the Offset Matrix with
   * per-car Initial Offset and Car Delta. Complements bank_level:
   * bank_level=true means own column with no per-car delta (bank-only),
   * individual=true means own column with per-car delta. Both false =>
   * mapping is merged into the grouped MessageContent category column.
   * bank_level wins when both are set.
   *
   * Appended at the end of the table to preserve `FlatBuffer` wire
   * compatibility — never insert fields in the middle.
   */
  individual(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Treat this mapping's MessageContent category as a group-shared
   * register: one register serves the whole group and is read/written
   * identically for every car (car delta 0). The Offset Matrix then does
   * NOT flag the same shared address appearing on multiple cars as a
   * cross-car overlap. Defaults on in the UI for Group Supervisory Status
   * and Group Control (group-scoped by definition), but is operator-
   * overridable per mapping.
   *
   * Appended at the end of the table to preserve `FlatBuffer` wire
   * compatibility — never insert fields in the middle.
   */
  groupShared(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Which of the two LN1 maps this key feeds.
   *
   * BOTH (the default) reproduces the historical behaviour exactly: the
   * key is emitted into `offset_to_msg` AND `msg_to_offset`. `TO_DEVICE`
   * emits into `msg_to_offset` only; `FROM_DEVICE` into `offset_to_msg`
   * only. Together they let one wire address carry a different LN2
   * message per direction — see `KeyDirection` in `enums.fbs`.
   *
   * Only meaningful when the owning adapter sets `direction_aware_keys`.
   * The server rejects a non-BOTH value on an adapter that has not opted
   * in, so a client ignoring the adapter flag cannot half-map an adapter
   * by accident.
   *
   * Appended at the end of the table to preserve `FlatBuffer` wire
   * compatibility — never insert fields in the middle.
   */
  direction(): KeyDirection {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : KeyDirection.BOTH;
  }

  static startKey(builder: flatbuffers.Builder) {
    builder.startObject(25);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addAdapterId(builder: flatbuffers.Builder, adapterIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, adapterIdOffset, 0);
  }

  static addFbsDeviceType(builder: flatbuffers.Builder, fbsDeviceType: LiftType) {
    builder.addFieldInt8(2, fbsDeviceType, LiftType.ELEVATOR);
  }

  static addEncodedType(builder: flatbuffers.Builder, encodedType: number) {
    builder.addFieldInt16(3, encodedType, 0);
  }

  static addMessageContent(builder: flatbuffers.Builder, messageContent: number) {
    builder.addFieldInt16(4, messageContent, 0);
  }

  static addMessageValue(builder: flatbuffers.Builder, messageValue: number) {
    builder.addFieldInt32(5, messageValue, 0);
  }

  static addContentType(builder: flatbuffers.Builder, contentType: number) {
    builder.addFieldInt32(6, contentType, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt16(7, position, 0);
  }

  static addLowerEncodedType(builder: flatbuffers.Builder, lowerEncodedType: number) {
    builder.addFieldInt16(8, lowerEncodedType, 0);
  }

  static addLowerMessageContent(builder: flatbuffers.Builder, lowerMessageContent: number) {
    builder.addFieldInt16(9, lowerMessageContent, 0);
  }

  static addLowerMessageValue(builder: flatbuffers.Builder, lowerMessageValue: number) {
    builder.addFieldInt32(10, lowerMessageValue, 0);
  }

  static addLowerFbsDeviceType(builder: flatbuffers.Builder, lowerFbsDeviceType: LiftType) {
    builder.addFieldInt8(11, lowerFbsDeviceType, LiftType.ELEVATOR);
  }

  static addLowerPosition(builder: flatbuffers.Builder, lowerPosition: number) {
    builder.addFieldInt16(12, lowerPosition, 0);
  }

  static addFloorsBased(builder: flatbuffers.Builder, floorsBased: boolean) {
    builder.addFieldInt8(13, +floorsBased, +false);
  }

  static addUnitsBased(builder: flatbuffers.Builder, unitsBased: boolean) {
    builder.addFieldInt8(14, +unitsBased, +false);
  }

  static addBankLevel(builder: flatbuffers.Builder, bankLevel: boolean) {
    builder.addFieldInt8(15, +bankLevel, +false);
  }

  static addDebounceTime(builder: flatbuffers.Builder, debounceTime: number) {
    builder.addFieldInt32(16, debounceTime, 0);
  }

  static addFloorIndexing(builder: flatbuffers.Builder, floorIndexingOffset: flatbuffers.Offset) {
    builder.addFieldOffset(17, floorIndexingOffset, 0);
  }

  static addValueBinary(builder: flatbuffers.Builder, valueBinaryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, valueBinaryOffset, 0);
  }

  static createValueBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startValueBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(19, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(20, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(21, deletedAtOffset, 0);
  }

  static addIndividual(builder: flatbuffers.Builder, individual: boolean) {
    builder.addFieldInt8(22, +individual, +false);
  }

  static addGroupShared(builder: flatbuffers.Builder, groupShared: boolean) {
    builder.addFieldInt8(23, +groupShared, +false);
  }

  static addDirection(builder: flatbuffers.Builder, direction: KeyDirection) {
    builder.addFieldInt8(24, direction, KeyDirection.BOTH);
  }

  static endKey(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // adapter_id
    return offset;
  }

  unpack(): KeyT {
    return new KeyT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.adapterId() !== null ? this.adapterId()!.unpack() : null,
      this.fbsDeviceType(),
      this.encodedType(),
      this.messageContent(),
      this.messageValue(),
      this.contentType(),
      this.position(),
      this.lowerEncodedType(),
      this.lowerMessageContent(),
      this.lowerMessageValue(),
      this.lowerFbsDeviceType(),
      this.lowerPosition(),
      this.floorsBased(),
      this.unitsBased(),
      this.bankLevel(),
      this.debounceTime(),
      this.floorIndexing(),
      this.bb!.createScalarList<number>(this.valueBinary.bind(this), this.valueBinaryLength()),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.individual(),
      this.groupShared(),
      this.direction(),
    );
  }

  unpackTo(_o: KeyT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    _o.fbsDeviceType = this.fbsDeviceType();
    _o.encodedType = this.encodedType();
    _o.messageContent = this.messageContent();
    _o.messageValue = this.messageValue();
    _o.contentType = this.contentType();
    _o.position = this.position();
    _o.lowerEncodedType = this.lowerEncodedType();
    _o.lowerMessageContent = this.lowerMessageContent();
    _o.lowerMessageValue = this.lowerMessageValue();
    _o.lowerFbsDeviceType = this.lowerFbsDeviceType();
    _o.lowerPosition = this.lowerPosition();
    _o.floorsBased = this.floorsBased();
    _o.unitsBased = this.unitsBased();
    _o.bankLevel = this.bankLevel();
    _o.debounceTime = this.debounceTime();
    _o.floorIndexing = this.floorIndexing();
    _o.valueBinary = this.bb!.createScalarList<number>(
      this.valueBinary.bind(this),
      this.valueBinaryLength(),
    );
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.individual = this.individual();
    _o.groupShared = this.groupShared();
    _o.direction = this.direction();
  }

  unpackFields(...fields: string[]): KeyT {
    const t = new KeyT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("adapter_id")) {
      t.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    }
    if (fieldSet.has("fbs_device_type")) {
      t.fbsDeviceType = this.fbsDeviceType();
    }
    if (fieldSet.has("encoded_type")) {
      t.encodedType = this.encodedType();
    }
    if (fieldSet.has("message_content")) {
      t.messageContent = this.messageContent();
    }
    if (fieldSet.has("message_value")) {
      t.messageValue = this.messageValue();
    }
    if (fieldSet.has("content_type")) {
      t.contentType = this.contentType();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    if (fieldSet.has("lower_encoded_type")) {
      t.lowerEncodedType = this.lowerEncodedType();
    }
    if (fieldSet.has("lower_message_content")) {
      t.lowerMessageContent = this.lowerMessageContent();
    }
    if (fieldSet.has("lower_message_value")) {
      t.lowerMessageValue = this.lowerMessageValue();
    }
    if (fieldSet.has("lower_fbs_device_type")) {
      t.lowerFbsDeviceType = this.lowerFbsDeviceType();
    }
    if (fieldSet.has("lower_position")) {
      t.lowerPosition = this.lowerPosition();
    }
    if (fieldSet.has("floors_based")) {
      t.floorsBased = this.floorsBased();
    }
    if (fieldSet.has("units_based")) {
      t.unitsBased = this.unitsBased();
    }
    if (fieldSet.has("bank_level")) {
      t.bankLevel = this.bankLevel();
    }
    if (fieldSet.has("debounce_time")) {
      t.debounceTime = this.debounceTime();
    }
    if (fieldSet.has("floor_indexing")) {
      t.floorIndexing = this.floorIndexing();
    }
    if (fieldSet.has("value_binary")) {
      t.valueBinary = this.bb!.createScalarList<number>(
        this.valueBinary.bind(this),
        this.valueBinaryLength(),
      );
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("individual")) {
      t.individual = this.individual();
    }
    if (fieldSet.has("group_shared")) {
      t.groupShared = this.groupShared();
    }
    if (fieldSet.has("direction")) {
      t.direction = this.direction();
    }
    return t;
  }
}

export class KeyT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public adapterId: UuidT | null = null,
    public fbsDeviceType: LiftType = LiftType.ELEVATOR,
    public encodedType: number = 0,
    public messageContent: number = 0,
    public messageValue: number = 0,
    public contentType: number = 0,
    public position: number = 0,
    public lowerEncodedType: number = 0,
    public lowerMessageContent: number = 0,
    public lowerMessageValue: number = 0,
    public lowerFbsDeviceType: LiftType = LiftType.ELEVATOR,
    public lowerPosition: number = 0,
    public floorsBased: boolean = false,
    public unitsBased: boolean = false,
    public bankLevel: boolean = false,
    public debounceTime: number = 0,
    public floorIndexing: string | Uint8Array | null = null,
    public valueBinary: number[] = [],
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public individual: boolean = false,
    public groupShared: boolean = false,
    public direction: KeyDirection = KeyDirection.BOTH,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.adapterId === null || this.adapterId === undefined) {
      throw new Error('Required field "adapter_id" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const adapterId = this.adapterId !== null ? this.adapterId!.pack(builder) : 0;
    const floorIndexing =
      this.floorIndexing !== null ? builder.createString(this.floorIndexing!) : 0;
    const valueBinary = Key.createValueBinaryVector(builder, this.valueBinary);
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    Key.startKey(builder);
    Key.addId(builder, id);
    Key.addAdapterId(builder, adapterId);
    Key.addFbsDeviceType(builder, this.fbsDeviceType);
    Key.addEncodedType(builder, this.encodedType);
    Key.addMessageContent(builder, this.messageContent);
    Key.addMessageValue(builder, this.messageValue);
    Key.addContentType(builder, this.contentType);
    Key.addPosition(builder, this.position);
    Key.addLowerEncodedType(builder, this.lowerEncodedType);
    Key.addLowerMessageContent(builder, this.lowerMessageContent);
    Key.addLowerMessageValue(builder, this.lowerMessageValue);
    Key.addLowerFbsDeviceType(builder, this.lowerFbsDeviceType);
    Key.addLowerPosition(builder, this.lowerPosition);
    Key.addFloorsBased(builder, this.floorsBased);
    Key.addUnitsBased(builder, this.unitsBased);
    Key.addBankLevel(builder, this.bankLevel);
    Key.addDebounceTime(builder, this.debounceTime);
    Key.addFloorIndexing(builder, floorIndexing);
    Key.addValueBinary(builder, valueBinary);
    Key.addCreatedAt(builder, createdAt);
    Key.addUpdatedAt(builder, updatedAt);
    Key.addDeletedAt(builder, deletedAt);
    Key.addIndividual(builder, this.individual);
    Key.addGroupShared(builder, this.groupShared);
    Key.addDirection(builder, this.direction);

    return Key.endKey(builder);
  }

  clone(): KeyT {
    const obj = new KeyT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.adapterId = this.adapterId !== null ? this.adapterId!.clone() : null;
    obj.fbsDeviceType = this.fbsDeviceType;
    obj.encodedType = this.encodedType;
    obj.messageContent = this.messageContent;
    obj.messageValue = this.messageValue;
    obj.contentType = this.contentType;
    obj.position = this.position;
    obj.lowerEncodedType = this.lowerEncodedType;
    obj.lowerMessageContent = this.lowerMessageContent;
    obj.lowerMessageValue = this.lowerMessageValue;
    obj.lowerFbsDeviceType = this.lowerFbsDeviceType;
    obj.lowerPosition = this.lowerPosition;
    obj.floorsBased = this.floorsBased;
    obj.unitsBased = this.unitsBased;
    obj.bankLevel = this.bankLevel;
    obj.debounceTime = this.debounceTime;
    obj.floorIndexing = this.floorIndexing;
    obj.valueBinary = [...this.valueBinary];
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.individual = this.individual;
    obj.groupShared = this.groupShared;
    obj.direction = this.direction;
    return obj;
  }

  equals(other: KeyT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.adapterId !== null && other.adapterId !== null) {
      if (!this.adapterId!.equals(other.adapterId!)) return false;
    } else if (this.adapterId !== other.adapterId) return false;
    if (this.fbsDeviceType !== other.fbsDeviceType) return false;
    if (this.encodedType !== other.encodedType) return false;
    if (this.messageContent !== other.messageContent) return false;
    if (this.messageValue !== other.messageValue) return false;
    if (this.contentType !== other.contentType) return false;
    if (this.position !== other.position) return false;
    if (this.lowerEncodedType !== other.lowerEncodedType) return false;
    if (this.lowerMessageContent !== other.lowerMessageContent) return false;
    if (this.lowerMessageValue !== other.lowerMessageValue) return false;
    if (this.lowerFbsDeviceType !== other.lowerFbsDeviceType) return false;
    if (this.lowerPosition !== other.lowerPosition) return false;
    if (this.floorsBased !== other.floorsBased) return false;
    if (this.unitsBased !== other.unitsBased) return false;
    if (this.bankLevel !== other.bankLevel) return false;
    if (this.debounceTime !== other.debounceTime) return false;
    if (this.floorIndexing !== other.floorIndexing) return false;
    if (this.valueBinary.length !== other.valueBinary.length) return false;
    for (let i = 0; i < this.valueBinary.length; i++) {
      if (this.valueBinary[i] !== other.valueBinary[i]) return false;
    }
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.individual !== other.individual) return false;
    if (this.groupShared !== other.groupShared) return false;
    if (this.direction !== other.direction) return false;
    return true;
  }
}

export function verifyKey(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "adapter_id");
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 2);
    verifier.checkScalarField(tablePos, 12, 2);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 2);
    verifier.checkScalarField(tablePos, 20, 2);
    verifier.checkScalarField(tablePos, 22, 2);
    verifier.checkScalarField(tablePos, 24, 4);
    verifier.checkScalarField(tablePos, 26, 1);
    verifier.checkScalarField(tablePos, 28, 2);
    verifier.checkScalarField(tablePos, 30, 1);
    verifier.checkScalarField(tablePos, 32, 1);
    verifier.checkScalarField(tablePos, 34, 1);
    verifier.checkScalarField(tablePos, 36, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 38);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 42);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 44);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 46);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 48, 1);
    verifier.checkScalarField(tablePos, 50, 1);
    verifier.checkScalarField(tablePos, 52, 1);
  } finally {
    verifier.popDepth();
  }
}
